import { jsx } from "react/jsx-runtime";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import { validateTidalLicense } from "../../base/index.js";
function RotateLeft(props) {
  return /* @__PURE__ */ jsx(
    RotateLeftIcon,
    {
      "data-testid": "RotateLeft",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "RotateLeft",
      "data-tidal-icon-meta": "arrows"
    }
  );
}
RotateLeft.tidalIconMeta = {
  categories: "arrows",
  name: "RotateLeft"
};
validateTidalLicense();
export {
  RotateLeft
};
//# sourceMappingURL=RotateLeft.js.map
